module.exports = __webpack_public_path__ + "static/media/democrat.7af94dda.svg";